import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreSonarObjectsSalesforceUpdateableAsyncSlice } from './post';

export const coreSonarObjectsSalesforceUpdateableReducers = combineReducers({
	post: postCoreSonarObjectsSalesforceUpdateableAsyncSlice.asyncReducers
});

export const coreSonarObjectsSalesforceUpdateableWatchers = combineAllWatchers([
	postCoreSonarObjectsSalesforceUpdateableAsyncSlice.asyncWatchers
]);
